import { EmployeeUser } from "../../types";
import { EditEmployeeForm } from "../form/first-login/edit-employee-form";
import { useEffect, useMemo, useState } from "react";
import { useToast } from "../../context/toast-context";
import { BranchService } from "../../services/branch-service";
import { Loading } from "../Loading";
import { Group } from "../../types";

interface EditEmployeeTabProps {
  employee: EmployeeUser;
  branchId: number;
  onEmployeeUpdated: () => void;
  onClose: () => void;
}

export function EditEmployeeTab({ 
  employee, 
  branchId, 
  onEmployeeUpdated,
  onClose 
}: EditEmployeeTabProps) {
  const [groups, setGroups] = useState<Group[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [equalSplitTip, setEqualSplitTip] = useState(false);
  const { showToast } = useToast();
  const branchService = useMemo(() => new BranchService(), []);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;
    const fetchBranchesInfo = async () => {
      setIsLoading(true);

      try {
        await branchService.getBranchesInformation(
          {
            limit: 100,
            offset: 0,
            branchid: branchId.toString(),
          },
          (data) => {
            setGroups(data[0].groups);
            setEqualSplitTip(data[0].equalSplitTip);
          },
          (error) => showToast(error, "error")
        );
      } finally {
        if (!signal.aborted) {
          setIsLoading(false);
        }
      }
    };

    fetchBranchesInfo();
    return () => {
      controller.abort();
    };
  }, [showToast, branchService, branchId]);

  return (
    <div className="flex flex-col gap-6">
      {isLoading && <Loading sidebar={false} />}
      {!isLoading && (
        <EditEmployeeForm 
          employee={employee}
          groups={groups}
          updateEmployees={onEmployeeUpdated}
          equalSplitTip={equalSplitTip}
          branchId={branchId}
          setIsModalOpen={onClose}
          fetchAll={true}
          onLeaveConfig={true}
        />
      )}
    </div>
  );
} 